import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {ISearchSuggestion} from "../../../../services/game-search/game-search-result";
import {SuggestedVideoSlidesFilterListPreviewTitleBox} from "./boxes/suggested-video-slides-filter-list-preview-title/suggested-video-slides-filter-list-preview-title.box";
import {SuggestedVideoSlidesFilterItemPreviewComponent} from "./components/suggested-video-slides-filter-item-preview/suggested-video-slides-filter-item-preview.component";
import {SuggestedVideoSlidesFilterListPreviewHeaderBox} from "./boxes/suggested-video-slides-filter-list-preview-header/suggested-video-slides-filter-list-preview-header.box";
import {SuggestedVideoSlidesFilterListPreviewBox} from "./boxes/suggested-video-slides-filter-list-preview.box";
import {SuggestedVideoSlidesFilterListPreviewContentBox} from "./boxes/suggested-video-slides-filter-list-preview-content/suggested-video-slides-filter-list-preview-content.box";
import {CyClass} from "../../../../../common/cy-classes";

interface SuggestedVideoSlidesFilterPreviewProps {
    items: ISearchSuggestion[];
}
export const SuggestedVideoSlidesFilterListPreviewComponent: React.FC<SuggestedVideoSlidesFilterPreviewProps> = observer((props) => {
    const services = useServices();
    let ExploreOutlinedIcon = services.theme.currentTheme.icons.exploreOutlinedIcon;

    return <SuggestedVideoSlidesFilterListPreviewBox className={CyClass('cy-video-slides-search-suggestions-container')}>
        <SuggestedVideoSlidesFilterListPreviewHeaderBox>
            <ExploreOutlinedIcon size={2.2} style={{marginRight: "10px", color: services.theme.currentTheme.colors.brandPrimary}} />
            <SuggestedVideoSlidesFilterListPreviewTitleBox>
                {services.translation.translate("VIDEO_SLIDES_FILTER_PREVIEW_TITLE")}
            </SuggestedVideoSlidesFilterListPreviewTitleBox>
        </SuggestedVideoSlidesFilterListPreviewHeaderBox>
        <SuggestedVideoSlidesFilterListPreviewContentBox>
            {
                props.items.map(videoSlidesFilterPreviewSuggestion => (
                    <SuggestedVideoSlidesFilterItemPreviewComponent
                        key={videoSlidesFilterPreviewSuggestion.key}
                        filterCount={props.items.length}
                        videoSlidesFilterPreviewSuggestion={videoSlidesFilterPreviewSuggestion} />
                ))
            }
        </SuggestedVideoSlidesFilterListPreviewContentBox>
    </SuggestedVideoSlidesFilterListPreviewBox>
});